export const financingTabNames = {
  SELECT_OFFER: 'SELECT_OFFER',
  DOWN_PAYMENT_AND_DELIVERY: 'DOWN_PAYMENT_AND_DELIVERY',
  FINALIZE_OFFER: 'FINALIZE_OFFER',
  CONTRACT_STATUS: 'CONTRACT_STATUS',
};
